module.exports = __webpack_public_path__ + "img/purple-square-table-1.a668ca33.png";